export default __webpack_public_path__ + "static/media/ecom.50e3a8a2.svg";